import React, {useEffect, useState} from "react";
import '../../styles/common/silent-mode-warning.scss';
import {subscribeToReceiveMessagesFromNativeApp} from "../../services/eventBus/nativeApp/receiveMessageFromNativeAppEventBus";
import Modal from "./Modal";
import {FontIcon} from "./FontIcon";
import {localStorageService} from "../../services/storage/local-storage";

// This variable is a bit misleading. It does not actual store value in sessionStorage, but merely in memory. Reloading
// the page will reset this variable.
let hasBeenShownThisSession = false;

export default function SilentModeWarning() {
  const [shouldDisplay, setShouldDisplay] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  // Get indicator to see if we can show the silent mode warning from local storage
  const canShowSilentModeWarningKey = "canShowSilentModeWarning";

  let canShowSilentModeWarning = localStorageService.getItem<string>("canShowSilentModeWarning");
  if (canShowSilentModeWarning === undefined) {
    canShowSilentModeWarning = "true";
  }

  // Subscribe to receive silent mode enabled / disabled from native app
  useEffect(()=>{
    return subscribeToReceiveMessagesFromNativeApp((message)=>{
      switch(message.type){
        case "silentModeChanged":
          if(hasBeenShownThisSession) {
            return;
          }
          if (canShowSilentModeWarning === "false") {
            return;
          }
          setShouldDisplay(message.isOn);
          break;
      }
    })
  });

  const el = shouldDisplay
    ?
    <Modal additionalClassName={`silent-mode-warning`} onClose={() => {
      hasBeenShownThisSession = true;
      setShouldDisplay(false);
      if (dontShowAgain) {
        localStorageService.setItem(canShowSilentModeWarningKey, "false");
      }
    }}>
      <div className={`header`}>
        <FontIcon icon={"icon-exclamation-triangle"}/>
        <h1 className={`title`}>Silent Mode Is On</h1>
      </div>
      <p className={`message`}>
        In order to hear sound in the app, silent mode must be off. Please swipe down from the top right of your screen
        and tap the bell icon, or toggle the notification switch on the side of your device, if it has one.
      </p>

      <p className={`dontShowAgainContainer`}>
        <input
          type="checkbox"
          id={"silentMode_dontShowAgainCheckbox"}
          checked={dontShowAgain}
          aria-label={"Don't show again"}
          title={"Don't show again"}
          onChange={() => {
            setDontShowAgain(!dontShowAgain);
          }}
        />

        <label className={"dontShowAgainCheckboxLabel"} htmlFor={"silentMode_dontShowAgainCheckbox"}>Don&apos;t show again</label>
      </p>
    </Modal>
    :
    null;
  return el;
}